export default{
    reporte:[],
    act:null,
    fields:'',
    error:null,
    errorMessage:'',
    totalRow:null,
    
    
}